// React.js (React Router) version Remove this file if not in used after testing
import { useEffect } from "react";

export default function Relay() {
  useEffect(() => {
    const token = sessionStorage.getItem("accessToken");
    const origin = new URLSearchParams(window.location.search).get("origin");

    if (token && origin) {
      window.opener?.postMessage({ type: "AUTH_TOKEN", token }, origin);
      window.close();
    }
  }, []);

  return <p>Relaying authentication token...</p>;
}
